<p-tree
  [value]="orgnodes"
  selectionMode="checkbox"
  autoWidth="false"
  [style]="{ width: '100%' }"
  styleClass="form-component"
  [(selection)]="selectedItems"
></p-tree>
